import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "dropdown-item" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "field-changes"
}
const _hoisted_4 = { class: "field-change" }
const _hoisted_5 = {
  key: 2,
  class: "meta"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("b", null, _toDisplayString(_ctx.line.heading), 1),
    (_ctx.line.description)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.line.description), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.line.heading === 'Transaction' && _ctx.line.updatedInformationFields?.length)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.line.updatedInformationFields, (field, index) => {
            return (_openBlock(), _createElementBlock("li", { key: index }, [
              _createElementVNode("strong", null, _toDisplayString(field.fieldName), 1),
              _cache[1] || (_cache[1] = _createTextVNode(": ", -1)),
              _createElementVNode("span", _hoisted_4, _toDisplayString(field.oldValue) + " → " + _toDisplayString(field.newValue), 1)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
    (_ctx.line.username)
      ? (_openBlock(), _createElementBlock("small", _hoisted_5, _toDisplayString(_ctx.line.username) + " • " + _toDisplayString(new Date(_ctx.line.timestamp).toLocaleString()), 1))
      : _createCommentVNode("", true)
  ]))
}